import React from 'react'
import useFormApi from "../../../cmn/docAutomation/useFormApi"
import * as fn from '../../../../helper/uiFunctions';
import SarasAMCStatus from '../../../../library/repeater/keyvalue/SarasAMCStatus';

const TaskDashRow = (props) => {
    const { viewData} = props;
    const dashRow = React.useRef();

    if (!viewData)
        return (null);

    const url = fn.getShowDocumentLink(viewData.dataList.valLDT, viewData.rId, "", 1, viewData.dataList.module, viewData.dataList.view);

    const urlTarget = viewData.dataList.windowTarget ? viewData.dataList.windowTarget : "_blank";

    const amcStatusInfo = viewData.dataList.amcStatusInfo ? JSON.parse(viewData.dataList.amcStatusInfo) : null;

    //convert amcStatusInfo to the format required for SarasAMCStatus component
    const statusItems = [
        { label: "Active", value: amcStatusInfo?.Active || 0, classKey: "Active" },
        { label: "Recent", value: amcStatusInfo?.Recent || 0, classKey: "Recent" },
        { label: "Archived", value: amcStatusInfo?.Archived || 0, classKey: "Archived" }
    ];

    // console.log("task dash row amc status", amcStatusInfo, statusItems);

    const amcUrl = fn.getSearchDocumentLink(703, null, null, 1, `initialCriteria=${encodeURIComponent(amcStatusInfo?.criteria || "")}`);

    const getStyle = () => {
        if (viewData.dataList.recordBarStyle !== "") {
            //alert(data.recordBarContainer.dataList.colCssStyle)
            return JSON.parse(viewData.dataList.recordBarStyle)
        }
        else {
            return {color:"#000"}
        }
    }

    return (
        <div className="uiFullWidth" style={{width:"100%"}} >
            <SarasAMCStatus hide={"0"} labelValuePair={statusItems} variant={"mini"} url={amcUrl} />
            <div className="uiRecordContainer">
                <a href={url} target={urlTarget}>
                    <div className="uiBar" style={getStyle()}>
                        <div className="uiInline uiH110" >
                            <span>{viewData.dataList.taskTitle}</span>
                        </div>
                        <div ref={dashRow} className={`uiInline uiDashRowRCol show-popup ${viewData.dataList.taskPriorityStyle}`}
                        >
                            <span className="uiCenterLabel">{viewData.dataList.taskPriority}</span>
                        </div>
                    </div>
                    <div className="uiBarInfo uiH110" style={{ display: viewData.dataList.taskSubTitle ? "" : "none" }}>
                        <span className="uiTaskDashRowSubTitle">{viewData.dataList.taskSubTitle}</span>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default TaskDashRow
